import { render, staticRenderFns } from "./pageCpn.vue?vue&type=template&id=e76580a2&scoped=true&"
import script from "./pageCpn.vue?vue&type=script&lang=js&"
export * from "./pageCpn.vue?vue&type=script&lang=js&"
import style0 from "./pageCpn.vue?vue&type=style&index=0&id=e76580a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e76580a2",
  null
  
)

export default component.exports